import { ElasticMatchplayMatchesMatchesInner, MatchplayGroupsGroupsInnerTeamsInner, TournamentEventTypeEnum } from '@spikemark/rest-api';
import { ClientTime } from '@spikemark/ui/components/client-time';
import { formatPlayerScore } from '@spikemark/ui/utils/format';
import { FC, PropsWithChildren } from 'react';
import { MatchResult } from './types';
const ScoreDisplay: FC<PropsWithChildren<{
  color?: string;
}>> = ({
  color,
  children
}) => <div className="flex justify-between items-center text-center text-2xl md:text-3xl lg:text-5xl font-bold leading-none text-gray-800 whitespace-nowrap my-1 lg:my-2" style={{
  color
}} data-sentry-component="ScoreDisplay" data-sentry-source-file="match-shared.tsx">
    <p className="font-black uppercase">{children}</p>
  </div>;
const TeeTimeDisplay: FC<PropsWithChildren> = ({
  children
}) => <p className="text-xs lg:text-sm font-normal" data-sentry-component="TeeTimeDisplay" data-sentry-source-file="match-shared.tsx">{children}</p>;
export const TeamMatchScore: FC<{
  result: MatchResult[];
  teeTime?: string;
  matchHasStarted?: boolean;
}> = ({
  result,
  teeTime,
  matchHasStarted
}) => {
  if (matchHasStarted === false && teeTime) {
    return <>
        <ScoreDisplay>
          <ClientTime time={teeTime} />
        </ScoreDisplay>
        <TeeTimeDisplay>First Tee Time</TeeTimeDisplay>
      </>;
  }
  const [a, b] = result;
  const winningColor = a.score > b.score ? a.color : b.score > a.score ? b.color : undefined;
  return <ScoreDisplay color={winningColor} data-sentry-element="ScoreDisplay" data-sentry-component="TeamMatchScore" data-sentry-source-file="match-shared.tsx">
      <span>{a.score}</span>
      {' - '}
      <span>{b.score}</span>
    </ScoreDisplay>;
};
export const MatchScore: FC<{
  match: ElasticMatchplayMatchesMatchesInner;
  teamA?: MatchplayGroupsGroupsInnerTeamsInner;
  teamB?: MatchplayGroupsGroupsInnerTeamsInner;
  teeTime?: string;
  matchHasStarted?: boolean;
  format: TournamentEventTypeEnum;
}> = ({
  match,
  teamA,
  teamB,
  teeTime,
  matchHasStarted,
  format
}) => {
  if (matchHasStarted === false && teeTime) {
    return <>
        <ScoreDisplay>
          <ClientTime time={teeTime} />
        </ScoreDisplay>
        <TeeTimeDisplay>Tee Time</TeeTimeDisplay>
      </>;
  }
  const winningColor = match.players[0].playerDetailUp > 0 ? [teamA, teamB].find(x => x?.schoolId === match.players[0].schoolId)?.schoolColour : match.players[1].playerDetailUp > 0 ? [teamA, teamB].find(x => x?.schoolId === match.players[1].schoolId)?.schoolColour : undefined;
  return <ScoreDisplay color={winningColor} data-sentry-element="ScoreDisplay" data-sentry-component="MatchScore" data-sentry-source-file="match-shared.tsx">
      {match.players[0].playerDetailUp > 0 ? formatPlayerScore(match.players[0], format) : match.players[1].playerDetailUp > 0 ? formatPlayerScore(match.players[1], format) : 'TIED'}
    </ScoreDisplay>;
};